import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { AlertModule, BreadcrumbModule, EmptyStateModule, LoaderModule, ModalModule, PaginatorModule, TableModule } from '@michelin/theme';
import { CopyOnSelectDirective } from '../../shared/directives/copy-on-select.directive';
import { AssignCamSpecComponent } from './components/assign-cam-spec/assign-cam-spec.component';
import { SearchCamSpecComponent } from './components/search-cam-spec/search-cam-spec.component';

@NgModule({
  declarations: [SearchCamSpecComponent, AssignCamSpecComponent],
  exports: [SearchCamSpecComponent, AssignCamSpecComponent],
  imports: [
    TableModule,
    BreadcrumbModule,
    EmptyStateModule,
    PaginatorModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    LoaderModule,
    ModalModule,
    AlertModule,
    CopyOnSelectDirective
  ]
})
export class SearchCamSpecModule {}
